var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex relative line-draw-container"},[_c('div',{staticClass:"flex self-center border-b-2 border-gris-moyen w-full z-0"}),_c('div',{staticClass:"absolute buttons-line w-full justify-center z-10 flex space-x-24"},_vm._l((_vm.titles),function(title){return _c('h3',{key:title,class:[
        'title',
        { 'text-gris-moyen': _vm.activeTab !== title },
        { 'text-gris': _vm.activeTab === title }
      ],on:{"click":function($event){return _vm.changeTab(title)}}},[_vm._v(" "+_vm._s(title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }